import { render, staticRenderFns } from "./ExtraOption.vue?vue&type=template&id=4f539620&scoped=true&"
import script from "./ExtraOption.vue?vue&type=script&lang=js&"
export * from "./ExtraOption.vue?vue&type=script&lang=js&"
import style0 from "./ExtraOption.vue?vue&type=style&index=0&id=4f539620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f539620",
  null
  
)

export default component.exports